import { render } from "./Landing.html?vue&type=template&id=133fa95e&scoped=true&ts=true&external"
import script from "./Landing.ts?vue&type=script&lang=ts&external"
export * from "./Landing.ts?vue&type=script&lang=ts&external"

import "./Landing.scss?vue&type=style&index=0&id=133fa95e&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133fa95e"]])

export default __exports__